<template>
	<div class="container row bg-background2" gutter="30">
		<!-- 大頭貼 後續補上 -->
		<!-- <el-upload action="" class="avatar-uploader">
			<img v-if="imageUrl" :src="imageUrl" class="avatar">
			<i v-else class="el-icon-plus avatar-uploader-icon center"></i>
		</el-upload> -->
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div class="col" gutter="30" style="flex:1;">
			<div class="col">
				<span>帳號</span>
				<span>{{userInfo.account}}</span>
			</div>
			<form-layout title="個人資料">
				<personal-info v-if="!isEditPersonInfo" @edit="isEditPersonInfo=true"></personal-info>
				<personal-info-form v-else @saved="isEditPersonInfo=false" @cancel="handlePersonInfoCancel"></personal-info-form>
			</form-layout>
			<form-layout title="工作經歷">
				<div v-for="(job, i) in jobs" :key="i" class="col" gutter="15">
					<div v-if="i>0" style="height:1px;width:100%;background-color:#c0c4cc;"></div>
					<resume v-if="!isEditResume[i]" @edit="handleResumEdit" :job="job" :index="i"></resume>
					<resume-form v-else @cancel="cancelEditResume" :job="job" :index="i" @deleteJob="deleteJob(i)">
						<!-- 加入 slot="button" 即可加入按鈕 -->
						<div class="button-tp color-white bg-danger" slot="button" style="width:114px; height:30px" v-if="userInfo.jobs.length>1" type="danger">移除</div>
					</resume-form>
				</div>
				<el-button @click="newJobs" icon="el-icon-circle-plus" style="width:100%;">點選新增經歷</el-button>
			</form-layout>
		</div>
	</div>
</template>

<script>
import {
	FormLayout,
	PersonalInfo,
	PersonalInfoForm,
	Resume,
	ResumeForm
} from "@/components/challenge/profile";
import { mapState } from "vuex";
import uuid from "uuid";
const _ = require("lodash");

export default {
	data() {
		return {
			isEditResume: [],
			isEditPersonInfo: false,
			imageUrl: "",
			jobs: []
		};
	},
	computed: {
		...mapState("user", ["userInfo"])
	},
	methods: {
		handlePersonInfoCancel() {
			this.isEditPersonInfo = false;
		},
		handleResumEdit(i) {
			console.log("handleResumEdit", i);
			this.initSingleJob(i);
			this.isEditResume[i] = true;
			this.isEditResume = _.cloneDeep(this.isEditResume);
			console.log(this.isEditResume);
		},
		newJobs() {
			let length = this.jobs && this.jobs.length || 0;
			this.jobs.push({ index: uuid.v4() });
			this.isEditResume[length] = true;
		},
		initJobs() {
			this.jobs = _.cloneDeep(this.userInfo.jobs);
		},
		initSingleJob(i) {
			if (this.userInfo.jobs[i]) {
				this.jobs[i] = _.cloneDeep(this.userInfo.jobs[i]);
			} else {
				this.deleteJob(i);
			}
		},
		deleteJob(i) {
			_.pullAt(this.jobs, i);
			this.jobs = _.cloneDeep(this.jobs);
			_.pullAt(this.isEditResume, i);
			this.isEditResume = _.cloneDeep(this.isEditResume);
		},
		cancelEditResume(i) {
			this.initSingleJob(i);
			this.isEditResume[i] = false;
			this.isEditResume = _.cloneDeep(this.isEditResume);
		}
	},
	created() {
		this.initJobs();
	},
	mounted() { },
	components: {
		FormLayout,
		PersonalInfo,
		PersonalInfoForm,
		Resume,
		ResumeForm
	},
	beforeRouteEnter(to, from, next) {
		const { query } = to;
		if (query.message) next(vm => vm.$alert(query.message, "提示", {
			confirmButtonText: "立刻檢查檢查",
			type: "warning"
		}).then(() => {
			vm.isEditResume.map(item => true);
			vm.isEditPersonInfo = true;
		}).catch(() => {
			vm.isEditResume.map(item => true);
			vm.isEditPersonInfo = true;
		}));
		else next()
	}
};
</script>

<style lang="scss" scoped>
.container {
	padding: 30px;
}
.right {
	flex: 1;
}
</style>

<style lang="scss">
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 100%;
	cursor: pointer;
	position: relative;
	overflow: hidden;

	&:hover {
		border-color: #409eff;
	}
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 80px;
	height: 80px;
	line-height: 80px;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}

.button {
	width: 150px;
	height: 30px;
}
</style>
